import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { UPLOAD_ROSTER } from '../actions/actionTypes';
import {
  uploadRosterDone,
  uploadRosterError,
  uploadRosterLoading,
  uploadRosterSuccess
} from '../actions/roster';
import { rosterApi } from '../api/RosterApi';

export function* watchUploadRosterSaga () {
  yield takeLatest(UPLOAD_ROSTER, uploadRosterSaga);
}

export function* uploadRosterSaga ({ eventId, csv }) {
  try {
    yield put(uploadRosterLoading());
    const roster = yield call(rosterApi.uploadRoster, eventId, csv);
    yield put(uploadRosterSuccess(roster));
  } catch (error) {
    yield put(uploadRosterError(error));
  } finally {
    yield put(uploadRosterDone());
  }
}

export default [
  fork(watchUploadRosterSaga)
];
